import {TAppState} from '../store'


export const selectUser_id = (state: TAppState) => state.profile._id